import React, { useState } from "react";
import { useActiveSessionId, useSessionHistory } from "../../slices/ui";
import { modelName, useAgentProvider } from "../../hook/agentProvider";

// The chat's model dropdown. Its list is the active provider's: Claude model names when the
// account provider is the Claude subscription, OpenRouter's catalog otherwise. Both come from the
// shared provider hook, so Settings shows exactly the same names and selection.
export function ModelPicker() {
  const { models, selectedModel, chooseModel } = useAgentProvider();
  const activeId = useActiveSessionId();
  const sessions = useSessionHistory();
  const [q, setQ] = useState("");

  // When an existing chat is active, lock the picker to that chat's stored model.
  // The user cannot change models mid-conversation; a new chat lifts the lock.
  const lockedModel = activeId
    ? (sessions.find((s) => s["session-id"] === activeId)?.model ?? selectedModel)
    : null;

  if (lockedModel) {
    return (
      <div
        className="model-picker"
        data-testid="model-locked"
        style={{ display: "flex", alignItems: "center", flex: 1, fontSize: 11, opacity: 0.7 }}
      >
        <span title="Model is fixed for an existing chat">{modelName(models, lockedModel)}</span>
      </div>
    );
  }

  const matched = models
    .filter((m) => (m.id + " " + m.name).toLowerCase().includes(q.toLowerCase()))
    .slice(0, 50);
  // The selected model is the one Settings shows as "for your next chat", so it
  // must always be an option here. Without this, a selected model beyond the
  // 50-row cap makes the native <select> display its first option instead.
  const selectedOption =
    models.find((m) => m.id === selectedModel) ?? { id: selectedModel, name: selectedModel };
  const filtered = matched.some((m) => m.id === selectedOption.id)
    ? matched
    : [selectedOption, ...matched];

  return (
    <div className="model-picker" style={{ display: "flex", alignItems: "center", gap: 4, flex: 1 }}>
      <input
        data-testid="model-search"
        placeholder="search models…"
        value={q}
        onChange={(e) => setQ(e.target.value)}
        style={{
          fontSize: 11,
          background: "transparent",
          border: "1px solid rgba(128,128,128,0.4)",
          borderRadius: 3,
          padding: "2px 6px",
          color: "inherit",
          width: 120,
          outline: "none",
        }}
      />
      <select
        data-testid="model-select"
        value={selectedModel}
        onChange={(e) => chooseModel(e.target.value)}
        style={{
          fontSize: 11,
          background: "transparent",
          border: "1px solid rgba(128,128,128,0.4)",
          borderRadius: 3,
          padding: "2px 4px",
          color: "inherit",
          flex: 1,
          maxWidth: 200,
        }}
      >
        {filtered.map((m) => (
          <option key={m.id} value={m.id}>
            {m.name}
          </option>
        ))}
      </select>
    </div>
  );
}
